import { React, Fragment, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { apiGetPolicyInfo } from "../../../../../utils/API/TrxNowAPI";
import { PolicyLookupSpinner } from "../../../PolicyLookupSpinner";
import nextIcon from "assets/icons/carat-r-white.png";
import "./PolicySelectionList.scss";
import { TVLConfirmNoCoverageModal } from "../TVLConfirmNoCoverageModal";
import { devLog } from "utils/devLog";

const policyMap = new Map();

export default function PolicySelectionList(props) {
  const { t } = useTranslation();

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const [policyNumber, setPolicyNumber] = useState(props.currState.PolicyNumber);

  const [policyData, setPolicyData] = useState(undefined);
  const [selectedVehicle, setSelectedVehicle] = useState(undefined);

  const [showConfirmCoverage, setShowConfirmCoverage] = useState(false);
  const [partnerCode, setPartnerCode] = useState(props.currState.localGroup);

  useEffect(() => {
    devLog(props);
    onSubmit();
  }, []);

  const onLoad = (success) => {
    if (typeof props.onLoad === "function") {
      props.onLoad(success);
    }
  };

  const onSubmit = (e) => {
    setError("");
    // e.preventDefault();
    devLog("Execute policy search...", policyNumber);

    if (policyMap.has(policyNumber)) {
      setPolicyData(policyMap.get(policyNumber));
      setLoading(false);
      onLoad(true);
      return;
    }

    setLoading(true);
    //Lookup: Callout
    apiGetPolicyInfo({
      data: {
        providerRef: props.currState.providerRef,
        firstName: props.currState.FirstName,
        lastName: props.currState.LastName,
        phone: props.currState.Number,
        policyNumber: policyNumber,
        partnerCode: partnerCode,
      },
      companyParams: props.currState.currentCompanyParams,
    })
      //Lookup: Success
      .then((json) => {
        devLog("JSON", json);
        if (typeof json.data.policy === "object") {
          setPolicyData(json.data.policy);
          if (json.data.error) {
            setError(json.data.error.message);
            onLoad(false);
          } else {
            policyMap.set(policyNumber, json.data.policy);
            onLoad(true);
          }
        } else if (typeof json.data.error === "object") {
          setError(json.data.error.message);
          policyMap.delete(policyNumber);
          onLoad(false);
        } else {
          setError("Unable to process policy lookup!");
          policyMap.delete(policyNumber);
          onLoad(false);
        }
        setLoading(false);
      })
      //Lookup: Failed
      .catch((e) => {
        devLog("error", e);
        setLoading(false);
        setError("Unable to process policy lookup!");
        onLoad(false);
      });
  };

  const onSelect = (vehicle) => {
    devLog("onSelect", vehicle);
    setSelectedVehicle(vehicle);

    if (vehicle && vehicle.coverage.length) {
      setShowConfirmCoverage(false);
      if (typeof props.onSelect === "function") {
        props.onSelect(policyData, vehicle);
      }
    } else {
      setShowConfirmCoverage(true);
    }
  };

  const onUserBack = (e) => {
    e.preventDefault();
    setShowConfirmCoverage(false);
    if (typeof props.onUserBack === "function") {
      props.onUserBack();
    }
  };

  const onConfirmCoverage = (e) => {
    setShowConfirmCoverage(false);
    if (typeof props.onSelect === "function") {
      props.onSelect(policyData, selectedVehicle);
    }
  };

  const onConfirmCoverageCancel = () => {
    setShowConfirmCoverage(false);
    setSelectedVehicle(undefined);
    if (typeof props.onSelect === "function") {
      props.onSelect(policyData, undefined);
    }
  };

  return (
    <>
      <div className="formContainer">
        {policyData ? (
          <div className="policyData">
            <div className="policyHeader">
              <h4>{t("description.PolicyInformationHeader2")}</h4>
              <hr />
              <div className="policy-info-line">
                <b>{t("description.ConfirmCustomerFirstName")}:</b> {policyData.firstName}
              </div>
              <div className="policy-info-line">
                <b>{t("description.ConfirmCustomerLastName")}:</b> {policyData.lastName}
              </div>
              <div className="policy-info-line">
                <b>{t("description.ConfirmCustomerPolicyNumber1")}:</b> {policyData.policyNumber}
              </div>
            </div>
            <div className="vehicleHeader">
              <h4 className="slim">{t("description.PolicyInformationHeader3")}</h4>
            </div>
            <div className="vehicle-list-container">
              <>
                {policyData.vehicles.map((item, index) => {
                  return (
                    <div
                      key={index}
                      value={item}
                      className={`vehicle-list-item ${selectedVehicle === item ? "selected" : ""}`}
                      onClick={(e) => {
                        onSelect(item);
                      }}
                    >
                      <div value={item} className="vehicle-list-item-col-1">
                        <h5 value={item}>
                          {item.make} {item.model} {item.year}
                        </h5>
                        {/* <p>{item.vin}</p> */}
                        <p></p>
                        <div className="coverage-list">
                          {item.coverage.length ? (
                            item.coverage.map((coverage, cIdx) => {
                              return <div key={`coverage-${cIdx}`}>{coverage.description}</div>;
                            })
                          ) : (
                            <></>
                          )}{" "}
                          {/*<div className="uncovered">No Coverage</div>*/}
                        </div>
                      </div>
                      <input
                        className="vehicleSelector"
                        type="radio"
                        name="policy-vehicle"
                        checked={selectedVehicle === item ? "selected" : ""}
                      />
                    </div>
                  );
                })}
                <div className="vehicleHeader">
                  <h4>{t("description.PolicyInformationHeader4")}</h4>
                  <span>{t("description.PolicyInformationHeader5")}</span>
                </div>
                <div
                  className={`vehicle-list-item ${selectedVehicle === null ? "selected" : ""}`}
                  onClick={(e) => {
                    onSelect(null);
                  }}
                >
                  <div className="vehicle-list-item-col-1">
                    <h5>Unlisted Vehicle</h5>
                    <div className="coverage-list">
                      {<></>} {/*<div className="uncovered">No Coverage</div>*/}
                    </div>
                  </div>
                  <input
                    className="vehicleSelector"
                    type="radio"
                    name="policy-vehicle"
                    checked={selectedVehicle === null ? "selected" : ""}
                  />
                </div>
              </>
            </div>
            <TVLConfirmNoCoverageModal
              isOpen={showConfirmCoverage}
              logo={props.currState.localGroupLogo}
              onYes={onConfirmCoverage}
              onNo={onConfirmCoverageCancel}
            />
          </div>
        ) : (
          <></>
        )}
      </div>
      {error ? (
        <div className="errorSection">
          <b className="error">{error}</b>
          <div>
            <button className="ui-btn" onClick={onUserBack}>
              Try Again
            </button>
          </div>
        </div>
      ) : (
        <></>
      )}
      {loading ? <PolicyLookupSpinner title={`PolicyLookupTitle`} message={`PolicyLookupMessage`} /> : <></>}
    </>
  );
}
